// @ts-expect-error -- there are no types for this library
import JsonApi from 'devour-client';

import type { Plan } from 'Backend/billing/types';
import type { JsonApiTypeHelper } from './JsonApiTypeHelper.types';

import Config from 'Config';
import { requestMiddleware, urlMiddleware } from './Middleware';

const PlansApi = new JsonApi({ apiUrl: Config.plans_api });

PlansApi.insertMiddlewareBefore('axios-request', requestMiddleware);
PlansApi.insertMiddlewareBefore('axios-request', urlMiddleware);

PlansApi.define('plan', {
    type: '',
    id: '',
    name: '',
    price: '',
    public: '',
    features: {
        apiAccess: '',
        xero: '',
        approvalWorkflows: '',
        brandedBusinessAccounts: '',
        lineItemExtraction: '',
        payroll: '',
        beneficiaryValidation: '',
        myob: '',
        bulkPayments: '',
        netsuite: '',
    },
    featureFees: {
        xero: '',
        approvalWorkflows: '',
        brandedBusinessAccounts: '',
        lineItemExtraction: '',
        payroll: '',
        beneficiaryValidation: '',
        bulkPayments: '',
    },
    platformLimits: {
        audAccounts: '',
        users: '',
    },
    platformFees: {
        audAccounts: '',
        users: '',
    },
    paymentLimits: {
        internationalDirect: '',
        fxMargin: '',
        realTimeDirectDebit: '',
        payroll: '',
        domesticPayments: '',
        fundDirectDebit: '',
        swift: '',
    },
    paymentFees: {
        internationalDirect: '',
        fxMargin: '',
        realTimeDirectDebit: '',
        payroll: '',
        domesticPayments: '',
        fundDirectDebit: '',
        swift: '',
    },
});

const PlansApiExport = PlansApi as JsonApiTypeHelper<Plan, 'plan'>;

export { PlansApiExport as PlansApi };
